import { useMutation } from '@tanstack/react-query'
import { UserController } from 'src/controllers/user.controller'

const userController = new UserController()

export function useResetPassword() {
  return useMutation<void, Error, string>({
    mutationKey: ['resetPassword'],
    mutationFn: (username: string) => userController.resetPassword(username)
  })
}
